import React, { useState, useEffect } from 'react'
import Invalid from '@/assets/certificate-gq.png'
import Valid from '@/assets/certificate-yx.png'
import Service from '@/services/account'
import './index.less'

export default (props) => {
  const {
    match: {
      params: { code },
    },
  } = props
  const [data, setData] = useState({})
  const certificateStatusValid = data.endTime
    ? new Date(data.endTime).getTime() > Date.now()
    : false

  useEffect(() => {
    Service.getCert(code).then((res) => {
      if (res.success) {
        setData(res.data)
      }
    })
  }, [])

  return (
    <div class="container">
      <div class="header">会员证书认证</div>
      <div class="inner">
        <img class="img" src={certificateStatusValid ? Valid : Invalid} />
        <div class="item">
          <div class="title">企业名称</div>
          <div class="content">{data.enterpriseName}</div>
        </div>
        <div class="item">
          <div class="title">会员类型</div>
          <div class="content">{data.memberType}</div>
        </div>
        {/* <div class="item">
          <div class="title">证书编号</div>
          <div class="content">{data.membershipCardNumber}</div>
        </div> */}
        <div class="item">
          <div class="title">统一社会信用代码</div>
          <div class="content">{data.organizationCode}</div>
        </div>
        <div class="item">
          <div class="title">发证单位</div>
          <div class="content">中国建筑业协会</div>
        </div>
        <div class="item">
          <div class="title">颁发日期</div>
          <div class="content">{data.startTime}</div>
        </div>
        <div class="item">
          <div class="title">有效期至</div>
          <div class="content">{data.endTime}</div>
        </div>
      </div>
    </div>
  )
}
